import { theme } from '@provi/provi-components'
import styled from 'styled-components'

export const CardRequestContainer = styled.div`
  font-family: 'Montserrat', sans-serif;

  border: 2px solid ${theme.colors.bluePrimaryLight};
  border-radius: 5px;
  background: #ffffff;
  max-width: 704px;
  min-height: 376px;
  padding: 24px;
`
export const CardRequestTitle = styled.h2`
  font-style: normal;
  font-family: 'Montserrat', sans-serif;

  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.01em;
  margin: 0;

  @media (max-width: 800px) {
    font-size: 16px;
    margin-bottom: 8px;
  }
`

export const CardRequestRow = styled.div`
  border-bottom: 1px solid ${theme.colors.bluePrimaryLight};
  padding-bottom: 16px;
  padding-top: 16px;
  > div {
    margin-bottom: 8px;
  }
  strong {
    font-weight: 600;
    font-size: 14px;
    color: #000;
  }
  span {
    font-weight: 500;
    font-size: 14px;
    color: #575757;
  }
  @media (max-width: 800px) {
    strong {
      margin-right: 8px;
    }
    div {
      display: flex;
    }
  }
`

export const CardRequestSubTitle = styled.h2`
  display: flex;
  font-family: 'Montserrat', sans-serif;

  flex-direction: row;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
  color: ${theme.colors.bluePrimary};
  align-items: center;
  svg {
    margin-right: 5px;
  }
`
export const CardRequestInfo = styled.div`
  background: ${theme.colors.bluePrimaryLight};
  font-family: 'Montserrat', sans-serif;

  padding: 12px;
  border-radius: 8px;
  margin-top: 24px;
  margin-bottom: 34px;
  font-size: 14px;
  position: relative;
  a {
    color: ${theme.colors.bluePrimaryDark};
    border-bottom: 1px solid ${theme.colors.bluePrimaryDark};
    margin-top: 8px;
    font-weight: 700;
  }
  svg {
    position: absolute;
  }
`

export const CardRequestCancellation = styled.a`
  font-style: normal;
  font-family: 'Montserrat', sans-serif;

  font-weight: 600;
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.02em;
  color: ${theme.colors.bluePrimary};
  > svg {
    margin-right: 8px;
  }
`

export const CardRequestWithdraw = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  font-family: 'Montserrat', sans-serif;

  color: #000;
`
export const CardRequestValueContainer = styled.div`
  margin-top: 16px;
  font-size: 14px;
`

export const CardDivider = styled.div`
  width: 290px;
  height: 1px;
  margin-bottom: 12px;
  background-color: ${theme.colors.bluePrimary};
`

export const CardRequestValue = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 290px;
  margin-bottom: 8px;
  color: #575757;
  span {
    font-weight: 600;
    font-size: 14px;
    color: #000;
    margin-right: 8px;
  }
`

export const CardRequestAccount = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 290px;
  margin-bottom: 8px;
  color: #575757;
  span {
    font-weight: 600;
    font-size: 14px;
    color: #000;
    margin-right: 8px;
  }
`

export const CardRequestInfoText = styled.div`
  padding-left: 40px;
  line-height: 20px;
  div {
    margin-bottom: 8px;
  }
  a {
    &:hover {
      cursor: pointer;
    }
  }
`

export const ModalBody = styled.div`
  padding: 24px 0;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13.2px;
  line-height: 20px;
  p {
    font-family: inherit;
    font-style: normal;
    font-weight: 500;
    font-size: 13.2px;
    line-height: 20px;
    color: #000000;
  }
`

export const EmptyRequests = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #000;
  max-width: 408px;
  line-height: 24px;
`
